export const setUser = ({ commit }, user) => {
  commit('UPDATE_USER', user)
}

export const rememberOrderFilters = ({ commit }, filters) => {
  commit('REMEMBER_FILTER', filters)
}

export const setSolution = ({ commit }, solution) => {
  commit('SET_SOLUTION', solution)
}

export const setOrder = ({ commit }, order) => {
  commit('SET_ORDER', order)
}

export const setHttp = ({ commit }, http) => {
  commit('SET_HTTP', http)
}

export const removeAddon = ({ commit }, addonId) => {
  commit('REMOVE_ADDON', addonId)
}


export const addAddon = ({ commit }, addon) => {
  commit('ADD_ADDON', addon)
}

export const clearOrder = ({ commit }) => {
  commit('RESET_ORDER', {});
}

export const setCustomer = ({ commit }, customer) => {
  commit('SET_CUSTOMER', customer);
}

export const clearState = ({ commit }) => {
  commit('RESET_USER', {});
  commit('RESET_ORDER', {});
}

export const clearOrderState = ({ commit }) => {
  commit('RESET_ORDER', {});
}

export const updateField = ({ commit }, object) => {

  if (object.store === "customer") {
    commit('SET_CUSTOMER_FIELD', { key: object.key, value: object.value })
  }

  if (object.store === "order") {
    commit('SET_ORDER_FIELD', { key: object.key, value: object.value })
  }
}
